<template>
  <a-row>
    <a-col :span="24">
      <a-descriptions
        :column="4"
        class="simiot-descriptions simiot-descriptions-max-10"
      >
        <a-descriptions-item label="销售业绩总额(元)">
          {{ data.total_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item
          v-if="canViewCostProfit"
          label="成本核算(元)"
        >
          {{ data.additional_cost | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item
          v-if="canViewCostProfit"
          label="毛利核算(元)"
        >
          <span :class="{ 'sale-profit-negative-text': isNegativeProfit }">
            {{ data.profit | formatCurrency }}
          </span>
        </a-descriptions-item>

        <a-descriptions-item
          v-if="canViewCostProfit"
          label="新增毛利(元)"
        >
          <span :class="{ 'sale-profit-negative-text': isNegativeAdditionalProfit }">
            {{ data.additional_profit | formatCurrency }}
          </span>
        </a-descriptions-item>

        <a-descriptions-item
          v-if="canViewCostProfit"
          label="存量毛利(元)"
        >
          <span :class="{ 'sale-profit-negative-text': isNegativeStoredProfit }">
            {{ data.stored_profit | formatCurrency }}
          </span>
        </a-descriptions-item>

        <a-descriptions-item label="新增卡量(张)">
          {{ data.new_cards_count | formatBigNumber }}
        </a-descriptions-item>

        <a-descriptions-item label="新增业绩-套餐(元)">
          {{ data.additional_product_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="套餐底价(元)">
          {{ data.floor_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="套餐底价差(元)">
          <span :class="{ 'sale-profit-negative-text': isNegativeSaleProfit }">
            {{ packageFloorDiffValue | formatCurrency }}
          </span>
        </a-descriptions-item>

        <a-descriptions-item label="新增业绩-卡板(元)">
          {{ data.additional_card_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="卡板底价(元)">
          {{ data.card_floor_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="卡板底价差(元)">
          <span :class="{ 'sale-profit-negative-text': isNegativeCardFloorDiff }">
            {{ cardFloorDiffValue | formatCurrency }}
          </span>
        </a-descriptions-item>

        <a-descriptions-item label="新增eSIM数量(个)">
          {{ data.new_esims_count | formatBigNumber }}
        </a-descriptions-item>

        <a-descriptions-item label="新增业绩-eSIM(元)">
          {{ data.additional_esim_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="eSIM底价(元)">
          {{ data.esim_floor_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="eSIM底价差(元)">
          <span :class="{ 'sale-profit-negative-text': isNegativeEsimFloorDiff }">
            {{ esimFloorDiffValue | formatCurrency }}
          </span>
        </a-descriptions-item>

        <a-descriptions-item label="新增Profile数量(个)">
          {{ data.new_profiles_count | formatBigNumber }}
        </a-descriptions-item>

        <a-descriptions-item label="新增业绩-Profile(元)">
          {{ data.additional_profile_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="Profile底价(元)">
          {{ data.profile_floor_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="Profile底价差(元)">
          <span :class="{ 'sale-profit-negative-text': isNegativeProfileFloorDiff }">
            {{ profileFloorDiffValue | formatCurrency }}
          </span>
        </a-descriptions-item>

        <a-descriptions-item label="新增模组数量(个)">
          {{ data.new_modules_count | formatBigNumber }}
        </a-descriptions-item>

        <a-descriptions-item label="新增业绩-模组(元)">
          {{ data.additional_module_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="模组底价(元)">
          {{ data.module_floor_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="模组底价差(元)">
          <span :class="{ 'sale-profit-negative-text': isNegativeModuleFloorDiff }">
            {{ moduleFloorDiffValue | formatCurrency }}
          </span>
        </a-descriptions-item>

        <a-descriptions-item label="新增CPE数量(个)">
          {{ data.new_cpes_count | formatBigNumber }}
        </a-descriptions-item>

        <a-descriptions-item label="新增业绩-CPE(元)">
          {{ data.additional_cpe_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="CPE底价(元)">
          {{ data.cpe_floor_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="CPE底价差(元)">
          <span :class="{ 'sale-profit-negative-text': isNegativeCpeFloorDiff }">
            {{ cpeFloorDiffValue | formatCurrency }}
          </span>
        </a-descriptions-item>

        <a-descriptions-item label="快递费(元)">
          {{ data.shipping_fee | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="存量业绩(元)">
          {{ data.stored_amount | formatCurrency }}
        </a-descriptions-item>

        <a-descriptions-item label="新增客户数(个)">
          {{ data.new_agents_count | formatBigNumber }}
        </a-descriptions-item>

        <a-descriptions-item label="客户总数(个)">
          {{ data.total_agents_count | formatBigNumber }}
        </a-descriptions-item>
      </a-descriptions>
    </a-col>
  </a-row>
</template>

<script>
import { findSaleMonthlyPerformance } from '@/api/sale_monthly_performance'
import { amountFloorDiff, canViewSaleCostProfit, cardFloorDiff, packageFloorDiff } from '@/utils/sale_monthly_performance'

export default {
  name: 'SaleMonthlyPerformanceInfoStatistic',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {}
    }
  },
  computed: {
    canViewCostProfit() {
      return canViewSaleCostProfit(this.$store.getters.userRole)
    },
    isNegativeProfit() {
      return this.data.profit != null && Number(this.data.profit) < 0
    },
    isNegativeAdditionalProfit() {
      return this.data.additional_profit != null && Number(this.data.additional_profit) < 0
    },
    isNegativeStoredProfit() {
      return this.data.stored_profit != null && Number(this.data.stored_profit) < 0
    },
    cardFloorDiffValue() {
      return cardFloorDiff(this.data.additional_card_amount, this.data.card_floor_amount)
    },
    isNegativeCardFloorDiff() {
      return this.cardFloorDiffValue < 0
    },
    packageFloorDiffValue() {
      return packageFloorDiff(this.data.additional_product_amount, this.data.floor_amount)
    },
    isNegativeSaleProfit() {
      return this.packageFloorDiffValue < 0
    },
    esimFloorDiffValue() {
      return amountFloorDiff(this.data.additional_esim_amount, this.data.esim_floor_amount)
    },
    isNegativeEsimFloorDiff() {
      return this.esimFloorDiffValue < 0
    },
    profileFloorDiffValue() {
      return amountFloorDiff(this.data.additional_profile_amount, this.data.profile_floor_amount)
    },
    isNegativeProfileFloorDiff() {
      return this.profileFloorDiffValue < 0
    },
    moduleFloorDiffValue() {
      return amountFloorDiff(this.data.additional_module_amount, this.data.module_floor_amount)
    },
    isNegativeModuleFloorDiff() {
      return this.moduleFloorDiffValue < 0
    },
    cpeFloorDiffValue() {
      return amountFloorDiff(this.data.additional_cpe_amount, this.data.cpe_floor_amount)
    },
    isNegativeCpeFloorDiff() {
      return this.cpeFloorDiffValue < 0
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findSaleMonthlyPerformance(this.id).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.setBreadcrumb()
        }
      })
    },

    setBreadcrumb() {
      if (this.$store.getters.userRole === 'sale') {
        this.$store.dispatch('ConcatDynamicBreadCrumbs', [
          { redirect: `/sale_monthly_performances/by_month?month=${this.data.month}`, meta: { title: this.data.month }}]
        ).then(() => {})
      } else if (this.$store.getters.userRole === 'sale_assistant') {
        this.$store.dispatch('ConcatDynamicBreadCrumbs', [
          { redirect: '/sale_monthly_performances', meta: { title: this.data.month }},
          { redirect: '', meta: { title: this.data.sale_full_name }}]
        ).then(() => {})
      } else {
        this.$store.dispatch('ConcatDynamicBreadCrumbs', [
          { redirect: `/sale_monthly_performances/by_month?month=${this.data.month}`, meta: { title: this.data.month }},
          { redirect: '', meta: { title: this.data.sale_full_name }}]
        ).then(() => {})
      }
    }
  }
}
</script>

<style scoped>
.sale-profit-negative-text {
  color: #f5222d;
}
</style>
